import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CommissionNote\GetCommissionNoteListController::__invoke
* @see app/Http/Controllers/CommissionNote/GetCommissionNoteListController.php
* @route '/api/commission-note-dashboard'
*/
const GetCommissionNoteListController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetCommissionNoteListController.url(options),
    method: 'post',
})

GetCommissionNoteListController.definition = {
    methods: ["post"],
    url: '/api/commission-note-dashboard',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CommissionNote\GetCommissionNoteListController::__invoke
* @see app/Http/Controllers/CommissionNote/GetCommissionNoteListController.php
* @route '/api/commission-note-dashboard'
*/
GetCommissionNoteListController.url = (options?: RouteQueryOptions) => {
    return GetCommissionNoteListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CommissionNote\GetCommissionNoteListController::__invoke
* @see app/Http/Controllers/CommissionNote/GetCommissionNoteListController.php
* @route '/api/commission-note-dashboard'
*/
GetCommissionNoteListController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetCommissionNoteListController.url(options),
    method: 'post',
})

export default GetCommissionNoteListController